// extracted by mini-css-extract-plugin
export default {"section":"Portfolio_section__VFNiM","section__container":"Portfolio_section__container__8Y+UW","section__heading":"Portfolio_section__heading__urp8j"};